// extracted by mini-css-extract-plugin
export default {"qrcode":"QRCode_qrcode__9p2vn","qrcodeImage":"QRCode_qrcodeImage__mttsx","welcomeInfo":"QRCode_welcomeInfo__BVV7J","score":"QRCode_score__M475P"};